
export enum ConversationTemplateRole {
    CorporateHR = 1,
    LocalHR = 2,
    Employee = 3,
    Manager = 33,
    Delegate = 333,
    Matrix = 3333,
    N2 = 4,
    Peer = 5,
    OtherEmployee = 6,
}
